import React from "react";

/**
 * Renders a currency amount with the decimal part visually smaller than the
 * integer part (keeps locale order: "50.000" big, ",00" small, " €" big).
 */
export function MoneyAmount({ value, currency = "EUR", className = "", decimalClassName = "" }) {
  const cur = (currency || "EUR").toUpperCase();
  let parts;
  try {
    parts = new Intl.NumberFormat("es-ES", { style: "currency", currency: cur }).formatToParts(Number(value || 0));
  } catch {
    parts = [{ type: "literal", value: `${cur} ${Number(value || 0).toFixed(2)}` }];
  }
  return (
    <span className={className}>
      {parts.map((p, i) =>
        p.type === "fraction" || p.type === "decimal"
          ? <span key={i} className={decimalClassName}>{p.value}</span>
          : <span key={i}>{p.value}</span>
      )}
    </span>
  );
}
